import { Injectable } from "@angular/core";
import { ActividadEconomica } from "../models/ActividadEconomica";
import { RegistroAlerta } from "../models/Alertas/RegistroAlerta";
import { Ambiente } from "../models/Ambiente";
import { TipoAnulacionBhe } from "../models/BoletaHonorarios/TipoAnulacionBhe";
import { CasillaDteRecibido } from "../models/CasillaDteRecibidos/CasillaDteRecibido";
import { TipoProveedorCorreo } from "../models/CasillaDteRecibidos/TipoProveedorCorreo";
import { TipoCorreoEnvio } from "../models/CorreoEnvio/TipoCorreoEnvio";
import { TipoPlantillaCorreoEnvio } from "../models/CorreoEnvio/TipoPlantillaCorreoEnvio";
import { EstadoAcuseEmitido } from "../models/Dte/EstadoAcuseEmitido";
import { EstadoDteRecibido } from "../models/Dte/EstadoDteRecibido";
import { CodigosAduana } from "../models/Dte/Exportacion/CodigosAduana";
import { Pais } from "../models/Dte/Exportacion/Pais";
import { Puerto } from "../models/Dte/Exportacion/Puerto";
import { TipoBulto } from "../models/Dte/Exportacion/TipoBulto";
import { ViaTransporte } from "../models/Dte/Exportacion/ViaTransporte";
import { RespuestaEstadoDte } from "../models/Dte/RespuestaEstadoDte";
import { Retencion } from "../models/Dte/Retencion";
import { TipoAcuseRecibo } from "../models/Dte/TipoAcuseRecibo";
import { Emisor } from "../models/Emisor/Emisor";
import { EstadoSii } from "../models/EstadoSii";
import { Facturable } from "../models/Facturable";
import { Impuesto } from "../models/Impuesto";
import { OrigenImportacionMasiva } from "../models/MassInvoicing/OrigenImportacionMasiva";
import { MonedaAduana } from "../models/MonedaAduana";
import { TipoReferencium } from "../models/Proveedor/TipoReferencium";
import { XmlTag } from "../models/Proveedor/XmlTag";
import { Comuna } from "../models/Region/Comuna";
import { Region } from "../models/Region/Region";
import { Sucursal } from "../models/Sucursal";
import { TipoComision } from "../models/TipoComision";
import { TipoDespacho } from "../models/TipoDespacho";
import { TipoDocumentoReferencia } from "../models/TipoDocRef";
import { TipoDte } from "../models/tipoDte";
import { TipoImpuesto } from "../models/TipoImpuesto";
import { TipoTraslado } from "../models/TipoTraslado";
import { Usuario } from "../models/Usuario/Usuario";
import { UtilitiesService } from "./utilities.service";
import { BehaviorSubject, Subject } from "rxjs";
import { Adicional } from "../models/Emisor/Adicional";
import { UserSession } from "../models/Usuario/UserSession";

@Injectable({
	providedIn: "root",
})
export class LocalStorageService {
	private TIPODTE_AGRUPADO_KEY = "local-tipodte-agrupado";
	private TIPODTE_KEY = "local-tipodte";
	private EMISORES_KEY = "local-emisores";
	private SUCURSALES_KEY = "local-sucursales";
	private ORIGEN_IMPORTACION = "local-importacion";
	private ESTADOS_DTE_RECIBIDOS = "local-estados-dte-recibidos";
	private CATEGORIA_ITEM_PLAN = "local-categoria-item-plan";
	private TIPO_ITEM_PLAN = "local-tipo-item-plan";
	private TIPO_ACUSE_RECIBO = "local-tipo-acuse-recibo";
	private TIPO_DOC_REFERENCIA = "local-tipo-doc-ref";
	private RESPUESTA_ESTADO__DTE = "local-respuesta-estado-dte";
	private FORMATO_PAPEL = "local-formato-papel";
	private FORMA_PAGO = "local-forma-pago";
	private IMPUESTOS_PRODUCTO = "local-impuestos";
	private TIPO_IMPUESTOS_PRODUCTO = "local-tipo-impuestos";
	private TIPO_RETENCIONES = "local-tipo-retenciones";
	private TIPO_TRASLADOS = "local-tipo-traslados";
	private TIPO_DESPACHO = "local-tipo-despacho";
	private FACTURABLES = "local-facturables";
	private CODIGOS_ADUANA = "local-codigos-aduana";
	private TIPO_COMISIONES = "local-tipo-comisiones";
	private PAISES = "local-paises";
	private PUERTOS = "local-puertos";
	private VIA_TRANSPORTE = "local-via-transporte";
	private MODALIDADES_VENTA = "local-modalidades-venta";
	private CLAUSULAS_VENTA = "local-clausulas-venta";
	private TIPO_BULTOS = "local-tipo-bultos";
	private ACTIVIDADES_ECONOMICAS = "local-actividades-economicas";
	private CASILLA_CORREO_DTE_RECIBIDOS = "local-casilla-correo-dte-recibidos";
	private XML_TAGS = "local-xml-tags";
	private CODE_REFERENCES = "local-code-references";
	private TIPO_PROVEEDOR_CORREO = "local-tipo-proveedor-correo";
	private MONEDAS_ADUANA = "local-monedas-aduana";
	private TIPO_AMBIENTE = "local-tipo-ambiente";
	private TIPO_CORREO_ENVIO = "local-tipo-correo-envio";
	private TIPO_PLANTILLA_ENVIO_CORREO = "local-tipo-plantilla-correo-envio";
	private USUARIOS = "local-usuarios";
	private TIPO_TRANSACCIONES = "local-tipo-transacciones";
	private ESTADOS_SII = "local-estados-sii";
	private PROPIEDAD_LOGOS = "local-propiedad-logos";
	private SUCURSALES_COMPLETO = "local-sucursales-completo";
	private NOTIFICACIONES_ALERTAS = "local-alertas";
	private ESTADO_ACUSE_EMITIDOS = "local-acuse-emitidos";
	private REGIONES = "local-regiones";
	private COMUNAS = "local-comunas";
	private TIPO_ANULACION_BHE = "local-anulacion-bhe";
	private ADICIONALES = "local-adicionales";

	private USUARIO_SESION = "local-usuario-sesion";
	private PREFIJO_BORRADOR_DTE = "local-dte-draft";
	private PREFIJO_BORRADOR_WIZARD_EMISOR = "local-wizard-emisor-draft";
	private RESOLUCIONES_KEY = "local-resoluciones";
	localContainer = window.localStorage;
	private sizeFormat = [
		{ id: 0, name: "Carta", size: 16 },
		{ id: 1, name: "_58mm", size: 8 },
		{ id: 2, name: "Ticket", size: 10000 },
	];
	private formaPago = [
		{ id: 1, nombreForma: "Contado" },
		{ id: 2, nombreForma: "Credito" },
		{ id: 3, nombreForma: "Sin Costo" },
	];

	environmentChanged: Subject<number> = new Subject();

	constructor(private utilities: UtilitiesService) {
		this.saveFormatoPapel();
		this.saveFormaPago();
	}

	public saveEstadosSii(estadoSii: EstadoSii[]) {
		this.localContainer.removeItem(this.ESTADOS_SII);
		this.localContainer.setItem(this.ESTADOS_SII, JSON.stringify(estadoSii));
	}

	public saveUserSession(useSession: UserSession): void {
		this.localContainer.removeItem(this.USUARIO_SESION);
		this.localContainer.setItem(this.USUARIO_SESION, JSON.stringify(useSession));
	}
	public getUserSession(): UserSession | null {
		const session = this.localContainer.getItem(this.USUARIO_SESION);
		return session != undefined ? (JSON.parse(session) as UserSession) : null;
	}

	public saveAdicionales(adicionales: Adicional[]) {
		this.localContainer.removeItem(this.ADICIONALES);
		this.localContainer.setItem(this.ADICIONALES, JSON.stringify(adicionales));
	}

	public getAdicionales(): Adicional[] {
		return JSON.parse(this.localContainer.getItem(this.ADICIONALES)) as Adicional[];
	}

	public getEstadosSii() {
		return this.localContainer.getItem(this.ESTADOS_SII);
	}

	public saveTipoCorreoEnvio(correoEnvio: TipoCorreoEnvio[]) {
		this.localContainer.removeItem(this.TIPO_CORREO_ENVIO);
		this.localContainer.setItem(this.TIPO_CORREO_ENVIO, JSON.stringify(correoEnvio));
	}

	public getTipooCorreoEnvio() {
		return this.localContainer.getItem(this.TIPO_CORREO_ENVIO);
	}
	public saveTipoPlantillaoCorreoEnvio(plantilla: TipoPlantillaCorreoEnvio[]) {
		this.localContainer.removeItem(this.TIPO_PLANTILLA_ENVIO_CORREO);
		this.localContainer.setItem(this.TIPO_PLANTILLA_ENVIO_CORREO, JSON.stringify(plantilla));
	}

	public getTipoPlantillaoCorreoEnvio() {
		return this.localContainer.getItem(this.TIPO_PLANTILLA_ENVIO_CORREO);
	}
	public saveTipoAmbiente(ambiente: Ambiente[]) {
		this.localContainer.removeItem(this.TIPO_AMBIENTE);
		this.localContainer.setItem(this.TIPO_AMBIENTE, JSON.stringify(ambiente));
	}

	public getTipoAmbiente() {
		return this.localContainer.getItem(this.TIPO_AMBIENTE);
	}
	public saveTipoProveedorCorreo(tipo: TipoProveedorCorreo[]) {
		this.localContainer.removeItem(this.TIPO_PROVEEDOR_CORREO);
		this.localContainer.setItem(this.TIPO_PROVEEDOR_CORREO, JSON.stringify(tipo));
	}

	public getTipoProveedorCorreo() {
		return this.localContainer.getItem(this.TIPO_PROVEEDOR_CORREO);
	}
	public saveCasillaCorreoDteRecibidos(casilla: CasillaDteRecibido[]) {
		this.localContainer.removeItem(this.CASILLA_CORREO_DTE_RECIBIDOS);
		this.localContainer.setItem(this.CASILLA_CORREO_DTE_RECIBIDOS, JSON.stringify(casilla));
	}

	public getCasillaCorreoDteRecibidos() {
		return this.localContainer.getItem(this.CASILLA_CORREO_DTE_RECIBIDOS);
	}
	public saveActividadesEconomicas(actividades: ActividadEconomica[]) {
		this.localContainer.removeItem(this.ACTIVIDADES_ECONOMICAS);
		this.localContainer.setItem(this.ACTIVIDADES_ECONOMICAS, JSON.stringify(actividades));
	}

	public getActividadesEconomicas() {
		return this.localContainer.getItem(this.ACTIVIDADES_ECONOMICAS);
	}
	public saveTipoComisiones(tipoComisiones: TipoComision[]) {
		this.localContainer.removeItem(this.TIPO_COMISIONES);
		this.localContainer.setItem(this.TIPO_COMISIONES, JSON.stringify(tipoComisiones));
	}

	public getTipoComisiones() {
		return this.localContainer.getItem(this.TIPO_COMISIONES);
	}
	public saveFacturables(facturables: Facturable[]) {
		this.localContainer.removeItem(this.FACTURABLES);
		this.localContainer.setItem(this.FACTURABLES, JSON.stringify(facturables));
	}

	public getFacturables() {
		return this.localContainer.getItem(this.FACTURABLES);
	}
	public saveTipoTraslados(TipoTraslados: TipoTraslado[]) {
		this.localContainer.removeItem(this.TIPO_TRASLADOS);
		this.localContainer.setItem(this.TIPO_TRASLADOS, JSON.stringify(TipoTraslados));
	}

	public getTipoTraslados() {
		return this.localContainer.getItem(this.TIPO_TRASLADOS);
	}
	public saveTipoDespacho(tipoDespacho: TipoDespacho[]) {
		this.localContainer.removeItem(this.TIPO_DESPACHO);
		this.localContainer.setItem(this.TIPO_DESPACHO, JSON.stringify(tipoDespacho));
	}

	public getTipoDespacho() {
		return this.localContainer.getItem(this.TIPO_DESPACHO);
	}

	public saveTipoImpuestos(tipoImpuestos: TipoImpuesto[]) {
		this.localContainer.removeItem(this.TIPO_IMPUESTOS_PRODUCTO);
		this.localContainer.setItem(this.TIPO_IMPUESTOS_PRODUCTO, JSON.stringify(tipoImpuestos));
	}

	public getTipoImpuestos() {
		return this.localContainer.getItem(this.TIPO_IMPUESTOS_PRODUCTO);
	}
	public saveRespuestaEstadoDte(respuestaEstado: RespuestaEstadoDte[]) {
		this.localContainer.removeItem(this.RESPUESTA_ESTADO__DTE);
		this.localContainer.setItem(this.RESPUESTA_ESTADO__DTE, JSON.stringify(respuestaEstado));
	}

	public getRespuestaEstadoDte() {
		return this.localContainer.getItem(this.RESPUESTA_ESTADO__DTE);
	}

	public getCategoriaItemPlan() {
		return this.localContainer.getItem(this.CATEGORIA_ITEM_PLAN);
	}
	public saveTipoAcuseRecibo(tipoAcuse: TipoAcuseRecibo[]) {
		this.localContainer.removeItem(this.TIPO_ACUSE_RECIBO);
		this.localContainer.setItem(this.TIPO_ACUSE_RECIBO, JSON.stringify(tipoAcuse));
	}

	public getTipoAcuseRecibo() {
		return this.localContainer.getItem(this.TIPO_ACUSE_RECIBO);
	}

	public getTipoItemPlan() {
		return this.localContainer.getItem(this.TIPO_ITEM_PLAN);
	}

	public saveEstadosDteRecibidos(dteRecibidosList: EstadoDteRecibido[]) {
		this.localContainer.removeItem(this.ESTADOS_DTE_RECIBIDOS);
		this.localContainer.setItem(this.ESTADOS_DTE_RECIBIDOS, JSON.stringify(dteRecibidosList));
	}

	public getEstadosDteRecibidos() {
		return this.localContainer.getItem(this.ESTADOS_DTE_RECIBIDOS);
	}

	public saveDteTypes(dteList: TipoDte[]) {
		this.localContainer.removeItem(this.TIPODTE_KEY);
		this.localContainer.setItem(this.TIPODTE_KEY, JSON.stringify(dteList));
	}

	public getDteTypes() {
		return this.localContainer.getItem(this.TIPODTE_KEY);
	}

	public saveEmisores(emisoresList: Emisor[]) {
		this.utilities.sortAlphabeth(emisoresList, "razonSocial");
		this.localContainer.removeItem(this.EMISORES_KEY);
		this.localContainer.setItem(this.EMISORES_KEY, JSON.stringify(emisoresList));
	}
	public getEmisores() {
		return this.localContainer.getItem(this.EMISORES_KEY);
	}

	public saveSucursales(sucursalesList: Sucursal[]) {
		this.utilities.sortAlphabeth(sucursalesList, "nombre");
		this.localContainer.removeItem(this.SUCURSALES_KEY);
		this.localContainer.setItem(this.SUCURSALES_KEY, JSON.stringify(sucursalesList));
	}

	public getSucursales() {
		return this.localContainer.getItem(this.SUCURSALES_KEY);
	}

	public saveOrigenImportaciones(listaImportaciones: OrigenImportacionMasiva[]) {
		this.localContainer.removeItem(this.ORIGEN_IMPORTACION);
		this.localContainer.setItem(this.ORIGEN_IMPORTACION, JSON.stringify(listaImportaciones));
	}

	public getOrigenImportaciones() {
		return this.localContainer.getItem(this.ORIGEN_IMPORTACION);
	}

	public saveTipoDocReferencias(tipos: TipoDocumentoReferencia[]) {
		this.localContainer.removeItem(this.TIPO_DOC_REFERENCIA);
		this.localContainer.setItem(this.TIPO_DOC_REFERENCIA, JSON.stringify(tipos));
	}

	public getTipoDocReferencias() {
		return this.localContainer.getItem(this.TIPO_DOC_REFERENCIA);
	}

	public saveFormatoPapel() {
		this.localContainer.removeItem(this.FORMATO_PAPEL);
		this.localContainer.setItem(this.FORMATO_PAPEL, JSON.stringify(this.sizeFormat));
	}

	public getFormatoPapel() {
		return this.localContainer.getItem(this.FORMATO_PAPEL);
	}

	public saveFormaPago() {
		this.localContainer.removeItem(this.FORMA_PAGO);
		this.localContainer.setItem(this.FORMA_PAGO, JSON.stringify(this.formaPago));
	}

	public getFormaPago() {
		return this.localContainer.getItem(this.FORMA_PAGO);
	}

	public saveImpuestos(impuestos: Impuesto[]) {
		this.localContainer.removeItem(this.IMPUESTOS_PRODUCTO);
		this.localContainer.setItem(this.IMPUESTOS_PRODUCTO, JSON.stringify(impuestos));
	}

	public getImpuestos() {
		return this.localContainer.getItem(this.IMPUESTOS_PRODUCTO);
	}

	public saveTipoRetenciones(tiposRetenciones: Retencion[]) {
		this.localContainer.getItem(this.TIPO_RETENCIONES);
		this.localContainer.setItem(this.TIPO_RETENCIONES, JSON.stringify(tiposRetenciones));
	}

	public getTiposRetenciones() {
		return this.localContainer.getItem(this.TIPO_RETENCIONES);
	}

	public saveCodigosAduana(codigos: CodigosAduana) {
		this.localContainer.removeItem(this.CODIGOS_ADUANA);
		this.localContainer.setItem(this.CODIGOS_ADUANA, JSON.stringify(codigos));
		this.savePaises(codigos.paises);
		this.savePuertos(codigos.puertos);
		this.saveTipoBultos(codigos.tipoBultos);
	}

	public getCodigosAduana(): CodigosAduana {
		return JSON.parse(this.localContainer.getItem(this.CODIGOS_ADUANA)) as CodigosAduana;
	}

	public saveMonedaAduanas(listaMonedas: MonedaAduana[]) {
		let lista = listaMonedas.filter((moneda) => moneda.pais != "CHILE");
		this.localContainer.removeItem(this.MONEDAS_ADUANA);
		this.localContainer.setItem(this.MONEDAS_ADUANA, JSON.stringify(lista));
	}

	public getMonedaAduanas(): MonedaAduana[] {
		return JSON.parse(this.localContainer.getItem(this.MONEDAS_ADUANA)) as MonedaAduana[];
	}

	public savePaises(paises: Pais[]) {
		this.localContainer.removeItem(this.PAISES);
		this.localContainer.setItem(this.PAISES, JSON.stringify(paises));
	}

	public getPaises(): Pais[] {
		return JSON.parse(this.localContainer.getItem(this.PAISES)) as Pais[];
	}

	public savePuertos(puertos: Puerto[]) {
		this.localContainer.removeItem(this.PUERTOS);
		this.localContainer.setItem(this.PUERTOS, JSON.stringify(puertos));
	}

	public getPuertos(): Puerto[] {
		return JSON.parse(this.localContainer.getItem(this.PUERTOS)) as Puerto[];
	}

	public saveTipoBultos(tipos: TipoBulto[]) {
		this.localContainer.removeItem(this.TIPO_BULTOS);
		this.localContainer.setItem(this.TIPO_BULTOS, JSON.stringify(tipos));
	}

	public getTipoBultos(): TipoBulto[] {
		return JSON.parse(this.localContainer.getItem(this.TIPO_BULTOS)) as TipoBulto[];
	}

	public saveViaTransportes(vias: ViaTransporte[]) {
		this.localContainer.removeItem(this.VIA_TRANSPORTE);
		this.localContainer.setItem(this.VIA_TRANSPORTE, JSON.stringify(vias));
	}

	public getViaTransportes() {
		return JSON.parse(this.localContainer.getItem(this.VIA_TRANSPORTE)) as ViaTransporte[];
	}

	public saveXmlTagList(xmlTagList) {
		this.localContainer.removeItem(this.XML_TAGS);
		this.localContainer.setItem(this.XML_TAGS, JSON.stringify(xmlTagList));
	}

	public saveCodeReferenceList(codeRefList) {
		this.localContainer.removeItem(this.CODE_REFERENCES);
		this.localContainer.setItem(this.CODE_REFERENCES, JSON.stringify(codeRefList));
	}

	public getXmlTagList(): XmlTag[] {
		return JSON.parse(this.localContainer.getItem(this.XML_TAGS)) as XmlTag[];
	}

	public getCodeReferenceList(): TipoReferencium[] {
		return JSON.parse(this.localContainer.getItem(this.CODE_REFERENCES)) as TipoReferencium[];
	}

	public updateAmbienteOfEmisor(emisorId: string, ambiente: number) {
		let emisores: Emisor[] = JSON.parse(this.getEmisores()) as Emisor[];
		let index = emisores.findIndex((em) => em.emisorId == emisorId);
		if (emisores[index] != undefined) {
			emisores[index].ambiente = ambiente;
		}
		this.localContainer.removeItem(this.EMISORES_KEY);
		this.localContainer.setItem(this.EMISORES_KEY, JSON.stringify(emisores));

		this.environmentChanged.next(ambiente);
		return emisorId;
	}

	public saveListaUsuarios(lista: Usuario[]) {
		lista.forEach((u) => {
			u.nombreCompleto = u.nombre + " " + u.apellidos;
		});
		this.localContainer.removeItem(this.USUARIOS);
		this.localContainer.setItem(this.USUARIOS, JSON.stringify(lista));
	}

	public getListaUsuarios(): Usuario[] {
		return JSON.parse(this.localContainer.getItem(this.USUARIOS)) as Usuario[];
	}

	public saveAllSucursales(all: Sucursal[]) {
		this.localContainer.removeItem(this.SUCURSALES_COMPLETO);
		this.localContainer.setItem(this.SUCURSALES_COMPLETO, JSON.stringify(all));
	}

	public getAllSucursales(): Sucursal[] {
		return JSON.parse(this.localContainer.getItem(this.SUCURSALES_COMPLETO)) as Sucursal[];
	}

	public saveAlertas(alertas: RegistroAlerta[]) {
		this.localContainer.removeItem(this.NOTIFICACIONES_ALERTAS);
		this.localContainer.setItem(this.NOTIFICACIONES_ALERTAS, JSON.stringify(alertas));
	}

	public updateAlertas(newAlert: RegistroAlerta) {
		let alertas = JSON.parse(this.localContainer.getItem(this.NOTIFICACIONES_ALERTAS)) as RegistroAlerta[];
		let changedAlertIndex = alertas.findIndex((a) => a.registroAlertaId == newAlert.registroAlertaId);
		alertas[changedAlertIndex] = newAlert;
		alertas.splice(changedAlertIndex, 1);
		this.saveAlertas(alertas);
	}
	public getAlertas(): RegistroAlerta[] {
		return JSON.parse(this.localContainer.getItem(this.NOTIFICACIONES_ALERTAS)) as RegistroAlerta[];
	}

	public saveEstadoAcuseEmitidos(lista: EstadoAcuseEmitido[]) {
		this.localContainer.removeItem(this.ESTADO_ACUSE_EMITIDOS);
		this.localContainer.setItem(this.ESTADO_ACUSE_EMITIDOS, JSON.stringify(lista));
	}

	public getEstadoAcuseEmitidos(): EstadoAcuseEmitido[] {
		return JSON.parse(this.localContainer.getItem(this.ESTADO_ACUSE_EMITIDOS)) as EstadoAcuseEmitido[];
	}

	public saveRegionesComunas(lista: Region[]) {
		this.localContainer.removeItem(this.REGIONES);
		this.localContainer.setItem(this.REGIONES, JSON.stringify(lista));
		let comunasArray = lista.map((region) => region.comunas);
		let soloComunas = comunasArray.reduce((comunaA, comunaB) => [...comunaA, ...comunaB], []);
		this.localContainer.removeItem(this.COMUNAS);
		this.localContainer.setItem(this.COMUNAS, JSON.stringify(soloComunas));
	}

	public getRegiones(): Region[] {
		return JSON.parse(this.localContainer.getItem(this.REGIONES)) as Region[];
	}

	public getComunas(): Comuna[] {
		return JSON.parse(this.localContainer.getItem(this.COMUNAS)) as Comuna[];
	}

	public getRegionOfComuna(regionId: string): Region {
		let regiones = this.getRegiones();
		let currentRegion = regiones.find((region) => region.regionId == regionId);
		return currentRegion;
	}

	public saveTipoAnulacionBhe(anulaciones: TipoAnulacionBhe[]) {
		this.localContainer.removeItem(this.TIPO_ANULACION_BHE);
		this.localContainer.setItem(this.TIPO_ANULACION_BHE, JSON.stringify(anulaciones));
	}

	public getTipoAnulacionBhe(): TipoAnulacionBhe[] {
		return JSON.parse(this.localContainer.getItem(this.TIPO_ANULACION_BHE)) as TipoAnulacionBhe[];
	}

	private construirClaveBorradorDte(userId: string, emisorId: string): string {
		return `${this.PREFIJO_BORRADOR_DTE}-${userId}-${emisorId}`;
	}

	public guardarContenedorBorradoresDte(userId: string, emisorId: string, payload: string): void {
		this.localContainer.setItem(this.construirClaveBorradorDte(userId, emisorId), payload);
	}

	public obtenerContenedorBorradoresDte(userId: string, emisorId: string): string | null {
		return this.localContainer.getItem(this.construirClaveBorradorDte(userId, emisorId));
	}

	public eliminarContenedorBorradoresDte(userId: string, emisorId: string): void {
		this.localContainer.removeItem(this.construirClaveBorradorDte(userId, emisorId));
	}

	public guardarBorradorWizardEmisor(userId: string, payload: string): void {
		this.localContainer.setItem(`${this.PREFIJO_BORRADOR_WIZARD_EMISOR}-${userId}`, payload);
	}

	public obtenerBorradorWizardEmisor(userId: string): string | null {
		return this.localContainer.getItem(`${this.PREFIJO_BORRADOR_WIZARD_EMISOR}-${userId}`);
	}

	public eliminarBorradorWizardEmisor(userId: string): void {
		this.localContainer.removeItem(`${this.PREFIJO_BORRADOR_WIZARD_EMISOR}-${userId}`);
	}

	public signOut() {
		const borradoresWizard = Array.from({ length: this.localContainer.length })
			.map((_, index) => this.localContainer.key(index))
			.filter((key): key is string => !!key && key.startsWith(this.PREFIJO_BORRADOR_WIZARD_EMISOR))
			.map(key => ({ key, value: this.localContainer.getItem(key) }));
		this.localContainer.clear();
		borradoresWizard.forEach(({ key, value }) => {
			if (value !== null) this.localContainer.setItem(key, value);
		});
	}

	public saveResolucion(rut: string, ambiente: string, data: { fechaResolucion: string, numeroResolucion: string }) {
		let resoluciones = JSON.parse(this.localContainer.getItem(this.RESOLUCIONES_KEY) || "{}");
		resoluciones[`${rut}_${ambiente}`] = data;
		this.localContainer.setItem(this.RESOLUCIONES_KEY, JSON.stringify(resoluciones));
	}

	public getResolucion(rut: string, ambiente: string): { fechaResolucion: string, numeroResolucion: string } | null {
		let resoluciones = JSON.parse(this.localContainer.getItem(this.RESOLUCIONES_KEY) || "{}");
		return resoluciones[`${rut}_${ambiente}`] || null;
	}
}
